const INITIAL_STATE = {
  credit: 0,
  cart_credit: 0,
  user: '',
  token: '',
  city_id: '',
  store_id: '',
  city_name: '',
  last_name: '',
  first_name: '',
  province_id: '',
  province_name: '',
  discount_code: '',
  is_login: false,
  login_required: false,
  close_adv: false,
  category_id: 1,
  catg_id: 0,
  catg_name: '',
  product_id: 1,
  c1: '',
  c2: '',
  c3: '',
  c4: '',
  c5: '',
  c6: '',

  cart_data: {
    total_amount: 0,
    total_quantity: 0,
    payable_amount: 0,
    discount_amount: 0,
    total_usable_credit: 0
  },
  carfilo_version: ''
};

const Login = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        catg_id: 0,
        catg_name: '',
        category_id: 1,
        first_name: action.user.first_name,
        last_name: action.user.last_name,
        credit: action.user.credit,
        close_adv: false,
        user: action.user,
        token: action.user.token,
        is_login: true,
        c1: '',
        c2: '',
        c3: '',
        c4: '',
        c5: '',
        c6: ''
      };

    case 'SET_LOGIN_REQUIRED':
      return {
        ...state,
        login_required: action.value
      };

    case 'SET_I_SUCCESS':
      return {
        ...state,
        first_name: action.user.first_name,
        last_name: action.user.last_name,
        credit: action.user.credit,
        user: action.user
      };

    case 'USER_EDIT_SUCCESS':
      return {
        ...state,
        first_name: action.user.first_name,
        last_name: action.user.last_name
      };

    case 'STORE_SUCCESS':
      return {
        ...state,
        city_id: action.city_id,
        province_id: action.province_id,
        store_id: action.store_id,
        province_name: action.province_name,
        city_name: action.city_name
      };

    case 'LOGOUT_SUCCESS':
      return {
        ...state,
        catg_id: 0,
        catg_name: '',
        category_id: 1,
        first_name: '',
        last_name: '',
        credit: 0,
        close_adv: false,
        user: '',
        token: '',
        is_login: false,
        discount_code: '',
        c1: '',
        c2: '',
        c3: '',
        c4: '',
        c5: '',
        c6: ''
      };

    case 'SET_DISCOUNT_CODE':
      return {
        ...state,
        credit: action.data.credit,
        discount_code: action.data.discount_code
      };

    case 'CLOSE_ADV':
      return { ...state, close_adv: true };

    case 'INIT_STATE':
      return { ...state };

    case 'INCREASE_CREDIT':
      return {
        ...state,
        cart_credit: state.cart_credit + action.credit,
        credit: state.credit - action.credit
      };

    case 'SET_CART_DATA':
      return {
        ...state,
        cart_credit: action.cart_credit,
        cart_data: action.cart_data
      };

    case 'SET_PRODUCT_ID':
      return {
        ...state,
        product_id: action.product_id,
        category_id: action.category_id
      };

    case 'SAVE_CATEGORY_ID':
      return { ...state, category_id: action.id };

    case 'SET_CATG':
      return { ...state, catg_id: action.catg_id, catg_name: action.catg_name };

    case 'SET_CATG_ROUTES':
      return {
        ...state,
        c1: action.c1,
        c2: action.c2,
        c3: action.c3,
        c4: action.c4,
        c5: action.c5,
        c6: action.c6
      };

    default:
      return state;
  }
};
export default Login;
